import React from 'react';
import { HelpCircle, Upload, History, TrendingUp, Shield, Users } from 'lucide-react';

const FAQButtons = ({ onFAQClick }) => {
  const faqs = [
    {
      question: "What is MedPlexity?",
      icon: HelpCircle,
      color: '#0277bd'
    },
    {
      question: "How can I upload my medical reports?",
      icon: Upload,
      color: '#4caf50'
    },
    {
      question: "What is My History?",
      icon: History,
      color: '#9c27b0'
    },
    {
      question: "Can MedPlexity predict future health risks?",
      icon: TrendingUp,
      color: '#ff9800'
    },
    {
      question: "Is this for doctors or patients?",
      icon: Users,
      color: '#e91e63'
    },
    {
      question: "Is my data safe?",
      icon: Shield,
      color: '#00bcd4'
    }
  ];

  return (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      padding: '1rem',
      boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
    }}>
      <div style={{
        fontSize: '0.85rem',
        color: '#78909c',
        marginBottom: '0.75rem',
        fontWeight: 500
      }}>
        💡 Quick Questions
      </div>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
      }}>
        {faqs.map((faq, idx) => {
          const Icon = faq.icon;
          return (
            <button
              key={idx}
              onClick={() => onFAQClick(faq.question)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '0.75rem 1rem',
                background: '#f8f9fa',
                border: '1px solid #e0e0e0',
                borderRadius: '10px',
                cursor: 'pointer',
                textAlign: 'left',
                fontSize: '0.9rem',
                color: '#37474f',
                transition: 'all 0.2s',
                width: '100%'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#e3f2fd';
                e.currentTarget.style.borderColor = '#0277bd';
                e.currentTarget.style.transform = 'translateX(4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#f8f9fa';
                e.currentTarget.style.borderColor = '#e0e0e0';
                e.currentTarget.style.transform = 'translateX(0)';
              }}
            >
              <div style={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                background: `${faq.color}15`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <Icon size={16} color={faq.color} />
              </div>
              <span style={{ fontWeight: 500 }}>{faq.question}</span>
            </button>
          );
        })}        
      </div>
    </div>
  );
};

export default FAQButtons;
